module.exports = __webpack_public_path__ + "static/media/success.fd6f8044.svg";